import r2wc from '@r2wc/react-to-web-component';
import UnitsSoldWebComponent from './UnitsSoldWebComponent';
const UnitsSoldWrappedWebComponent = r2wc(UnitsSoldWebComponent, {
    shadow: 'open',
    props: {
        commonOrgId: 'string',
        partition: 'string',
    },
});
if (!customElements.get('cmd-ctr-units-sold')) {
    customElements.define('cmd-ctr-units-sold', UnitsSoldWrappedWebComponent);
}
export { 
// eslint-disable-next-line import/prefer-default-export
UnitsSoldWrappedWebComponent, };
